import optional from './OptionalAccess';


export const writeHTMLToNewWindow = (name, html) => {
  const tab = window.open('', name);
  if (!tab) {
    // this.setState({ showPopupBlockedMessage: true });
    return null;
  }

  tab.document.write(html);
  tab.document.close();

  return tab;
};

export const formatJson = (json) => {
  // parse request body string
  const requestBody = optional(json, ['request', 'body']);
  if (requestBody) {
    try {
      json.request.body = JSON.parse(requestBody);
    } catch (e) {
      // do nothing
    }
  }

  // parse response body string
  const responseBody = optional(json, ['response', 'body']);
  if (responseBody) {
    try {
      json.response.body = JSON.parse(responseBody);
    } catch(e) {
      // do nothing
    }
  }

  // remove metadata
  if (json.metadata) {
    delete json['metadata'];
  }

  // return formatted JSON string
  return JSON.stringify(json, null, 2);
};

export const highlightSyntaxJson = (json) => {
  const jsonCopy = json
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  return jsonCopy.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
    function(match) {
      let cls = 'number';
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'key';
        } else {
          cls = 'string';
        }
      } else if (/true|false/.test(match)) {
        cls = 'boolean';
      } else if (/null/.test(match)) {
        cls = 'null';
      }
      return '<span class="' + cls + '">' + match + '</span>';
    },
  );
};

export const displayJsonTemplate = `<!doctype html>
<html>
  <head>
    <title>{reportType} Report</title>
    <style>
      pre { padding: 5px; margin: 5px; }
      .string { color: green; }
      .number { color: blue; }
      .boolean { color: red; }
      .null { color: grey; }
      .key { color: black; }
    </style>
  </head>
  <body>
    <pre>{json}</pre>
  </body>
</html>`;

export const fakeClick = (obj) => {
  const ev = document.createEvent('MouseEvents');
  ev.initMouseEvent(
    'click',
    true,
    false,
    window,
    0,
    0,
    0,
    0,
    0,
    false,
    false,
    false,
    false,
    0,
    null,
  );

  obj.dispatchEvent(ev);
};

export const exportRaw = (name, data) => {
  const urlObject = window.URL || window.webkitURL || window;
  const exportBlob = new Blob([data]);

  if ('msSaveBlob' in navigator) {
    // Prefer msSaveBlob if available - Edge supports a[download] but
    // ignores the filename provided, using the blob UUID instead.
    // msSaveBlob will respect the provided filename
    navigator.msSaveBlob(exportBlob, name);
  } else if ('download' in HTMLAnchorElement.prototype) {
    const saveLink = document.createElementNS(
      'http://www.w3.org/1999/xhtml',
      'a',
    );
    saveLink.href = urlObject.createObjectURL(exportBlob);
    saveLink.download = name;

    fakeClick(saveLink);
  } else {
    throw new Error('Neither a[download] nor msSaveBlob is available');
  }
};


// WEBPACK FOOTER //
// ./src/helpers/ReportHistoryHelper.js